export const GOOGLE_CONTENT_BLOCKED_MESSAGE =
  'Our safety filters could not process this request. Please rephrase your prompt and try again.';

/** Recognizes Google's policy codes and the message variants returned around them. */
export function isGoogleContentPolicyError(value: string): boolean {
  return /prohibited_content|content_blocked|input blocked|request blocked|sensitive words|prohibited use policy|policy reason/i.test(
    value
  );
}

export function userFacingGenerationError(
  value: string | null | undefined,
  fallback: string
): string {
  const message = value?.trim() ?? '';
  if (isGoogleContentPolicyError(message)) return GOOGLE_CONTENT_BLOCKED_MESSAGE;
  return message || fallback;
}
